import React, { useEffect, useState } from 'react';
import { db } from '../firebase';
import {
  collection,
  getDocs,
  doc,
  getDoc,
  setDoc,
  updateDoc,
} from 'firebase/firestore';

const RecipeEditor = () => {
  const [recipes, setRecipes] = useState([]);
  const [selectedId, setSelectedId] = useState('');
  const [recipeData, setRecipeData] = useState(null);
  const [isCreatingNew, setIsCreatingNew] = useState(false);

  // Fetch recipe list
  useEffect(() => {
    const fetchRecipes = async () => {
      const snapshot = await getDocs(collection(db, 'recipes'));
      setRecipes(snapshot.docs.map(doc => ({ id: doc.id, name: doc.data().name })));
    };
    fetchRecipes();
  }, []);

  // Load selected recipe
  useEffect(() => {
    const fetchRecipe = async () => {
      if (!selectedId || isCreatingNew) return;
      const docRef = doc(db, 'recipes', selectedId);
      const snap = await getDoc(docRef);
      if (snap.exists()) {
        setRecipeData(snap.data());
      }
    };
    fetchRecipe();
  }, [selectedId, isCreatingNew]);

  const handleIngredientChange = (index, field, value) => {
    const updated = [...recipeData.ingredients];
    updated[index][field] = field === 'amount_g' ? Number(value) : value;
    setRecipeData({ ...recipeData, ingredients: updated });
  };

  const addIngredient = () => {
    setRecipeData({
      ...recipeData,
      ingredients: [...recipeData.ingredients, { code: '', product: '', amount_g: 0 }],
    });
  };

  const removeIngredient = (index) => {
    const updated = recipeData.ingredients.filter((_, i) => i !== index);
    setRecipeData({ ...recipeData, ingredients: updated });
  };

  const saveRecipe = async () => {
    const recipeId = isCreatingNew
      ? recipeData.name.toLowerCase().replace(/[^a-z0-9]+/g, '_')
      : selectedId;

    const docRef = doc(db, 'recipes', recipeId);
    await setDoc(docRef, recipeData);
    alert(isCreatingNew ? '✅ New recipe added!' : '✅ Recipe updated!');
    window.location.reload(); // refresh to update dropdown
  };

  const createNewRecipe = () => {
    setIsCreatingNew(true);
    setSelectedId('');
    setRecipeData({ name: '', ingredients: [] });
  };

  return (
    <div>
      <h2>✏️ Recipe Ingredient Editor</h2>

      <button onClick={createNewRecipe}>➕ Create New Recipe</button>
      <br /><br />

      <label>Select Recipe to Edit: </label>
      <select
        value={selectedId}
        onChange={e => {
          setSelectedId(e.target.value);
          setIsCreatingNew(false);
          setRecipeData(null);
        }}
      >
        <option value="">-- Choose --</option>
        {recipes.map(r => (
          <option key={r.id} value={r.id}>{r.name}</option>
        ))}
      </select>

      {recipeData && (
        <div>
          <br />
          <label>Recipe Name: </label>
          <input
            type="text"
            value={recipeData.name}
            onChange={e => setRecipeData({ ...recipeData, name: e.target.value })}
          />

          <h3>Ingredients:</h3>
          {recipeData.ingredients.map((ing, index) => (
            <div key={index}>
              <input
                placeholder="Code"
                value={ing.code || ''}
                onChange={e => handleIngredientChange(index, 'code', e.target.value)}
              />
              <input
                placeholder="Product"
                value={ing.product}
                onChange={e => handleIngredientChange(index, 'product', e.target.value)}
              />
              <input
                type="number"
                placeholder="Amount (g)"
                value={ing.amount_g}
                onChange={e => handleIngredientChange(index, 'amount_g', e.target.value)}
              />
              <button onClick={() => removeIngredient(index)}>🗑️</button>
            </div>
          ))}

          <button onClick={addIngredient}>➕ Add Ingredient</button>
          <br /><br />
          <button onClick={saveRecipe}>💾 {isCreatingNew ? 'Save New Recipe' : 'Save Changes'}</button>
        </div>
      )}
    </div>
  );
};

export default RecipeEditor;
